import React from 'react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { trackApplyButton } from '@/utils/dataLayer';
import { useHorizontalMouseScroll } from '@/utils/useHorizontalMouseScroll';
import { MdOutlineKeyboardDoubleArrowDown } from 'react-icons/md';

const ProgramsInfoHero = () => {
  const { t } = useTranslation();
  const sliderRef = useHorizontalMouseScroll();

  const features = [
    {
      title: t('programs-page.hero-feature-1-title'),
      description: t('programs-page.hero-feature-1-description'),
    },
    {
      title: t('programs-page.hero-feature-2-title'),
      description: t('programs-page.hero-feature-2-description'),
    },
    {
      title: t('programs-page.hero-feature-3-title'),
      description: t('programs-page.hero-feature-3-description'),
    },
    {
      title: t('programs-page.hero-feature-4-title'),
      description: t('programs-page.hero-feature-4-description'),  
    },
  ];

  return (
    <div className="w-full bg-white">
      <div className="max-w-[98%] lg:max-w-[90%] mx-auto px-[15px] md:px-4 lg:px-0 md:pt-[100px] md:pb-[60px]">
        <div className="flex flex-col lg:flex-row gap-[30px] md:gap-[40px] lg:gap-[50px] items-center justify-center">
          <div className="flex-1 flex flex-col gap-[12px] md:gap-[20px] w-full min-w-0">
            <span className="text-[20px] md:text-[28px] font-[600] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">
              {t('programs-page.hero-section-title')}
            </span>

            <h1
              className="text-[32px] md:text-[48px] font-[500] text-black leading-tight text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]"
              dangerouslySetInnerHTML={{ __html: t('programs-page.hero-title') }}
            />

            <p className="text-[14px] md:text-[16px] lg:text-[20px] font-[400] leading-[160%] text-black max-w-full lg:max-w-[90%]">
              {t('programs-page.hero-description')}
            </p>

            <Link
              href="/apply"
              className="w-full"
              onClick={() => trackApplyButton('programs_hero')}
            >
              <button className="w-full md:w-[200px] lg:w-[235px] h-[48px] md:h-[56px] bg-main-pink border border-main-pink text-white text-[16px] font-[500] rounded-full hover:bg-white hover:text-main-pink transition-colors duration-300">
                {t('apply-btn')}
              </button>
            </Link>
          </div>

          <div
            ref={sliderRef}
            className="flex-1 w-full min-w-0 flex flex-nowrap gap-3 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden cursor-pointer select-none lg:flex-col lg:gap-4 lg:overflow-visible lg:snap-none lg:cursor-default lg:select-auto"
          >
            {features.map((feature, index) => {
              const isLast = index === features.length - 1;

              return (
                <article
                  key={feature.title}
                  className={`flex flex-none w-[calc(100%-60px)] flex-row gap-2 lg:w-full ${isLast ? 'snap-end' : 'snap-start'}`}
                >
                  <div className="min-w-[32px] h-[32px] rounded-full flex items-center justify-center flex-shrink-0 bg-main-pink">
                    <MdOutlineKeyboardDoubleArrowDown className="text-white w-[16px] h-[16px] md:w-[20px] md:h-[20px]" />
                  </div>
                  <div className="flex flex-col gap-2 min-w-0">
                    <h3 className="text-[16px] md:text-[18px] lg:text-[20px] font-[600] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884] leading-tight">
                      {feature.title}
                    </h3>
                    <p className="text-[14px] font-[400] leading-[160%] text-[#202020CC]">
                      {feature.description}
                    </p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramsInfoHero;
